// extracted by mini-css-extract-plugin
export default {"function":"_3d0ca51f8d534c22","bold":"b1576dcb90030ef6"};